
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import AuthPageLayout from '@/components/auth/AuthPageLayout';

export default function VerifyEmailConfirmPage() {
  const navigate = useNavigate();
  const { user, isLoading, verifyEmail } = useAuth();

  useEffect(() => {
    if (!isLoading && !user) {
      navigate('/login', { replace: true });
    }
  }, [user, isLoading, navigate]);

  const handleContinue = () => {
    verifyEmail();
    navigate('/configuraciones/resumen');
  };

  const handleDashboard = () => {
    verifyEmail();
    navigate('/dashboard');
  };

  return (
    <AuthPageLayout
      leftIcon="check_circle"
      leftTitle="¡Todo listo!"
      leftSubtitle="Tu cuenta está verificada y segura. Estás a un paso de potenciar tu comercio."
    >
      <div className="flex-1 flex items-center justify-center p-4 sm:p-12 lg:p-24">
        <div className="w-full max-w-md space-y-8 text-center">
          <div className="flex md:hidden justify-center mb-6">
            <div className="flex items-center gap-2">
              <span className="material-icons text-primary text-3xl">account_balance_wallet</span>
              <span className="font-bold text-2xl tracking-tight text-gray-900 dark:text-white">FLUX</span>
            </div>
          </div>

          <div className="flex justify-center mb-6">
            <div className="w-24 h-24 bg-green-50 dark:bg-green-900/20 rounded-full flex items-center justify-center animate-bounce shadow-sm">
              <span className="material-icons text-accent-green text-6xl">check_circle</span>
            </div>
          </div>

          <div className="text-center">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white mb-3">
              Correo verificado
            </h2>
            <p className="text-slate-500 dark:text-gray-400 text-lg leading-relaxed">
              Tu cuenta ha sido creada exitosamente. Ahora continuemos con la configuración de tu comercio.
            </p>
          </div>

          <div className="mt-8 space-y-4">
            <button
              onClick={handleContinue}
              className="group relative w-full flex justify-center py-4 px-4 border border-transparent text-base font-bold rounded-xl text-white bg-primary hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary shadow-lg shadow-blue-500/30 transition-all transform hover:-translate-y-0.5"
            >
              Continuar configuración
              <span className="absolute right-4 flex items-center">
                <span className="material-icons text-blue-200 group-hover:text-white transition-colors text-sm">
                  arrow_forward
                </span>
              </span>
            </button>

            <div className="pt-2">
              <button
                onClick={handleDashboard}
                className="inline-flex items-center justify-center text-sm font-medium text-slate-500 hover:text-primary transition-colors"
              >
                Ir al Dashboard
                <span className="material-icons text-sm ml-1">dashboard</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </AuthPageLayout>
  );
}
